import * as React from "react"

interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
    orientation?: "horizontal" | "vertical"
    decorative?: boolean
}

const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
    (
        {
            orientation = "horizontal",
            decorative = true,
            className,
            ...props
        },
        ref
    ) => {
        const baseStyles = "bg-border"
        
        const orientationStyles = {
            horizontal: "h-[1px] w-full",
            vertical: "h-full w-[1px]"
        }

        return (
            <div
                ref={ref}
                role={decorative ? "none" : "separator"}
                aria-orientation={orientation === "vertical" ? "vertical" : undefined}
                className={`${baseStyles} ${orientationStyles[orientation]} ${className || ""}`}
                {...props}
            />
        )
    }
)

Divider.displayName = "Divider"

export { Divider }